import { Box } from '@mui/material'
import { Button } from '../../../components/buttons'
import CancelConfirmDialog from '../../../components/dialogs/CancelConfirmDialog'
import { useDialogState } from '../../../components/dialogs/useDialogState'
import ReloadIcon from '../../../components/icons/ReloadIcon'
import { WorkloadUnitToggleGroup } from '../../../components/toggleGroups'
import DisplayFormatButton from '../../../containers/BulkSheetView/components/header/DisplayFormatButton'
import ColumnSettingButton from '../../../containers/BulkSheetView/components/header/ColumnSettingButton'
import FavoriteColumnFilterButton from '../../../containers/BulkSheetView/components/header/FavoriteColumnFilterButton'
import FileExportButton from '../../../containers/BulkSheetView/components/header/FileExportButton'
import FilterButton from '../../../containers/BulkSheetView/components/header/FilterButton'
import SortButton from '../../../containers/BulkSheetView/components/header/SortButton'
import { colorPalette } from '../../../style/colorPalette'
import { WorkloadUnit } from '../../../../lib/functions/workload'
import { ColDef } from 'ag-grid-community'
import { SortedColumnState } from '../../../model/bulkSheetColumnSortState'

type Props = {
  workloadUnit: WorkloadUnit | undefined
  onChangeWorkloadUnit: (value: WorkloadUnit) => void
  onCancel: () => void
  isLoading: boolean
  onDeleteSortedColumn?: ((column: string | ColDef<any>) => void) | undefined
  onDeleteSortedAllColumns: (() => void) | undefined
  onChangeSortColumnState?:
    | ((column: string | ColDef<any>, sort: 'asc' | 'desc' | null) => void)
    | undefined
  rowHeight: number | undefined
  onChangeHeight: (value: number) => void
  onClickExportExcel: () => void
  onClickFavoriteColumnFilterButton: () => void
  onClickColumnSettingButton: (e) => void
  filteredColumns: ColDef[]
  onDeleteFilteredColumn?: (column: ColDef) => void
  resetFilters: () => void
  sortColumnsState: SortedColumnState[]
  currentFormat?: string | undefined
  onChangeDateFormat: (value: string) => void
  columnSettingOpen: boolean
}

const TicketListsWbsHeader = ({
  workloadUnit,
  onChangeWorkloadUnit,
  onCancel,
  onDeleteSortedColumn,
  onDeleteSortedAllColumns,
  onChangeSortColumnState,
  rowHeight,
  onChangeHeight,
  onClickExportExcel,
  onClickFavoriteColumnFilterButton,
  onClickColumnSettingButton,
  filteredColumns,
  onDeleteFilteredColumn,
  resetFilters,
  sortColumnsState,
  currentFormat,
  onChangeDateFormat,
  columnSettingOpen,
}: Props) => {
  const [showCancelDialog, openCancelDialog, closeCancelDialog] =
    useDialogState()
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        margin: '10px 20px 10px 10px',
        overflowX: 'auto',
        overflowY: 'hidden',
        minHeight: '47px',
      }}
    >
      <Button
        onClick={openCancelDialog}
        sx={{
          background: colorPalette.monotone[1],
          border: '1px solid #9FACC3',
          borderRadius: '50%',
          height: '28px',
          width: '28px',
          marginRight: '10px',
          padding: '5px 8px',
          cursor: 'pointer',
          '&:hover': { background: colorPalette.monotone[1] },
        }}
      >
        <ReloadIcon />
      </Button>
      <CancelConfirmDialog
        open={showCancelDialog}
        onConfirm={() => {
          closeCancelDialog()
          onCancel()
        }}
        onClose={closeCancelDialog}
      />
      <WorkloadUnitToggleGroup
        refresh={value => {
          onChangeWorkloadUnit(value)
        }}
        value={workloadUnit}
      />
      <FilterButton
        filteredColumns={filteredColumns}
        onDeleteFilteredColumn={onDeleteFilteredColumn}
        resetFilters={resetFilters}
      />
      <SortButton
        onDeleteSortedColumn={onDeleteSortedColumn}
        onDeleteSortedAllColumns={onDeleteSortedAllColumns}
        onChangeSortColumnState={onChangeSortColumnState}
        sortColumnsState={sortColumnsState}
      />
      <ColumnSettingButton
        onClick={onClickColumnSettingButton}
        open={columnSettingOpen}
      />
      <FavoriteColumnFilterButton onClick={onClickFavoriteColumnFilterButton} />
      <DisplayFormatButton
        height={rowHeight}
        onChangeHeight={onChangeHeight}
        currentFormat={currentFormat}
        onChangeDateFormat={onChangeDateFormat}
      />
      <Box sx={{ display: 'flex', flexDirection: 'row', gap: '5px' }}>
        <FileExportButton onClickExport={onClickExportExcel} />
      </Box>
    </div>
  )
}

export default TicketListsWbsHeader
